import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
    GrafanaPassport,
    GrafanaLoadState,
    GrafanaPassportFormState,
    GrafanaPassportID,
    GrafanaPassportHeader,
    initGrafanaPassport,
    GrafanaDashboardSearchRes,
} from "userful-chronos-app-common-js/dist/models/integration/grafana";
import {
    requestListPassports,
    requestAddPassport,
    requestRemovePassport,
    requestUpdatePassport,
    requestListDashboards,
} from "./msgs/grafanaMsgSender";

const initialState: {
    grafanaPassports: GrafanaPassport[];
    loadState: GrafanaLoadState;
    passport: GrafanaPassport;
    copyPassport: GrafanaPassport;
    formType: GrafanaPassportFormState;
    openForm: boolean;
    grafanaDashboards: GrafanaDashboardSearchRes[];
} = {
    grafanaPassports: [],
    loadState: "RENDER",
    passport: initGrafanaPassport(),
    copyPassport: initGrafanaPassport(),
    formType: "Create",
    openForm: false,
    grafanaDashboards: [],
};

export const grafanaSlice = createSlice({
    name: "grafanaSlice",
    initialState,
    reducers: {
        setPassports: (state, action: PayloadAction<GrafanaPassport[]>) => {
            state.grafanaPassports = action.payload;
        },
        addOrUpdatePassport: (state, action: PayloadAction<GrafanaPassport>) => {
            const foundIndex = state.grafanaPassports.findIndex((item) => item.id.value === action.payload.id.value);
            if (foundIndex < 0) {
                state.grafanaPassports = [...state.grafanaPassports, { ...action.payload }];
            } else {
                state.grafanaPassports = [
                    ...state.grafanaPassports.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.grafanaPassports.slice(foundIndex + 1),
                ];
            }
        },
        removePassport: (state, action: PayloadAction<GrafanaPassportID>) => {
            state.grafanaPassports = state.grafanaPassports.filter((item) => item.id.value !== action.payload.value);
        },
        getPassportsFromServer: (state, action: PayloadAction<{}>) => {
            requestListPassports();
        },
        addPassportToServer: (state, action: PayloadAction<GrafanaPassportHeader>) => {
            requestAddPassport(action.payload);
        },
        updatePassportToServer: (state, action: PayloadAction<GrafanaPassportHeader>) => {
            requestUpdatePassport(action.payload);
        },
        removePassportToServer: (state, action: PayloadAction<GrafanaPassportID>) => {
            requestRemovePassport(action.payload);
        },
        changeLoadState: (state, action: PayloadAction<GrafanaLoadState>) => {
            state.loadState = action.payload;
        },
        setPassport: (state, action: PayloadAction<GrafanaPassport>) => {
            state.passport = action.payload;
        },
        setCopyPassport: (state, action: PayloadAction<GrafanaPassport>) => {
            state.copyPassport = action.payload;
        },
        setFormType: (state, action: PayloadAction<GrafanaPassportFormState>) => {
            state.formType = action.payload;
        },
        setOpenForm: (state, action: PayloadAction<boolean>) => {
            state.openForm = action.payload;
        },
        requestDashboards: (state, action: PayloadAction<GrafanaPassportID>) => {
            requestListDashboards(action.payload);
        },
        setDashboards: (state, action: PayloadAction<GrafanaDashboardSearchRes[]>) => {
            state.grafanaDashboards = action.payload;
        },
    },
});

export const grafanaActions = grafanaSlice.actions;

export default grafanaSlice.reducer;
